import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Faktury.scss";

// prop types
import fakturyPropTypes from "../../propTypes/fakturyPropTypes";

// components
import GridDetail from "./GridDetail";
import Grid from "../../zisComponents/grid/Grid";
import ErrorMsg from "../ErrorMsg";
import Button from "../../coraWebComponents/buttons/Button";
import { buildUrl } from "../../coraWebComponents/utils/helper";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as fakturyActions from "../../actions/faktury/fakturyActions";

const CmdCell = (props) => {
  const { field, dataItem, getFakturaPDF } = props;
  return (
    <>
      {dataItem[field] === 1 && (
        <Button
          imageUrl={buildUrl("assets/notify_stiahnut.svg")}
          onClick={async () =>
            await getFakturaPDF(
              dataItem.I_ZIS_FAKT_HL,
              `Faktura_${dataItem.C_FAKTURY}.pdf`
            )
          }
        />
      )}
    </>
  );
};

class Faktury extends React.Component {
  constructor(props) {
    super(props);

    this.gridFilter = { filters: [] };
    this.gridSort = [];
    this.gridPage = { skip: 0, take: 10 };

    this.Detail = GridDetail();
  }

  // GRID PROPS

  genGridSchema() {
    return [
      { field: "C_FAKTURY", title: "Názov faktury", width: "auto" },
      { field: "SUMA_FAKTURY", title: "Suma spolu", width: "auto" },
      {
        field: "D_VYSTAVENIA",
        title: "Dátum vystavenia",
        filter: "date",
        width: "auto",
        format: "{0:dd.MM.yyyy}"
      },
      {
        field: "D_SPLATNOSTI",
        title: "Dátum splatnosti",
        filter: "date",
        width: "auto",
        format: "{0:dd.MM.yyyy}"
      },
      {
        field: "L_BD",
        title: "Stiahnuť",
        width: "80",
        filter: "cmd",
        cell: (props) => <CmdCell {...this.props} {...props} />,
      },
    ];
  }
  genGridDetailSchema() {
    return [];
  }
  onChangeHandle = (filter, sort, page) => {
    this.gridFilter = filter;
    this.gridSort = sort;
    this.gridPage = page;
  };
  getListFakturaHandle = async () => {
    const { customFilters, getListFaktura } = this.props;
    const { gridFilter, gridSort, gridPage } = this;

    await getListFaktura(gridFilter, gridSort, gridPage, customFilters);
  };

  // SYSTEM METHODS;
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(true);
    changeHeaderTitle("Faktúry");
  }
  render() {
    const { isZmluvaPicked, isLoading, listFaktura, total } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <Grid
            className={isZmluvaPicked ? "" : "hidden"}
            data={listFaktura}
            isLoading={isLoading}
            onChange={this.onChangeHandle}
            onGet={() => { }}
            onGetList={this.getListFakturaHandle}
            primaryField="I_ZIS_FAKT_HL"
            schema={this.genGridSchema()}
            detailSchema={this.genGridDetailSchema()}
            total={total}
            detail={this.Detail}
          />
          {!isZmluvaPicked && <ErrorMsg text="Vyberte zmluvu" />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // list faktura/pdf
    customFilters: state.listFaktura.customFilters,
    isLoading: state.listFaktura.isLoading || state.fakturaPDF.isLoading,
    listFaktura: state.listFaktura.data,
    total: state.listFaktura.total,

    // zmluva
    isZmluvaPicked: state.zmluva.isPicked,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getFakturaPDF: async (id, fileName) => await dispatch(fakturyActions.getFakturaPDF(id, fileName)),
  getListFaktura: async (gridFilter, gridSort, gridPage, customFilters) =>
    await dispatch(
      fakturyActions.getListFaktura({
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
      })
    ),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Faktury.propTypes = {
  customFilters: PropTypes.arrayOf(PropTypes.object),
  getFakturaPDF: PropTypes.func,
  getListFaktura: PropTypes.func,
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool,
  isZmluvaPicked: PropTypes.bool,
  listFaktura: PropTypes.arrayOf(fakturyPropTypes.faktura),
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(Faktury);
